import React from 'react';
import PropTypes from 'prop-types';

const RightArrow = ( { type = 'none', size, color }) =>
{
    const up = () =>
    {
        return (
            <svg width={size} height={size} version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path d="m350 14c-70.547 0-138.21 28.023-188.09 77.91-49.887 49.883-77.91 117.54-77.91 188.09s28.023 138.21 77.91 188.09c49.883 49.887 117.54 77.91 188.09 77.91 46.691 0 92.562-12.289 133-35.637 40.438-23.348 74.016-56.926 97.363-97.363 23.348-40.438 35.637-86.309 35.637-133 0-70.547-28.023-138.21-77.91-188.09-49.883-49.887-117.54-77.91-188.09-77.91zm130.76 289.35-100.8 100.8c-8.0039 8.0039-19.668 11.129-30.602 8.1992-10.93-2.9297-19.469-11.469-22.398-22.402-2.9297-10.93 0.19531-22.594 8.1992-30.598l48.441-47.992h-142.02c-11.285 0-21.711-6.0195-27.355-15.793-5.6406-9.7695-5.6406-21.809 0-31.582 5.6445-9.7734 16.07-15.793 27.355-15.793h141.34l-47.656-47.711c-8.0039-8.0039-11.129-19.668-8.1992-30.598 2.9297-10.934 11.469-19.473 22.398-22.402 10.934-2.9297 22.598 0.19531 30.598 8.1992l100.8 100.8c6.2031 6.2148 9.5117 14.746 9.1289 23.52v1.0078c0.019531 8.3828-3.3086 16.422-9.2383 22.344z" fill={color}/>
                </g>
            </svg>
        )
    }

    switch ( type )
    {
        case 'up' :
            return up() ;
        default:
            return up() ;
    }
}

export default RightArrow ;

RightArrow.propTypes = {
    type: PropTypes.string
};

